module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel panel-default panel-search"
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "批次号"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.page.query.param.batchNo),
      callback: function($$v) {
        _vm.$set(_vm.page.query.param, "batchNo", $$v)
      },
      expression: "page.query.param.batchNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    directives: [{
      name: "keycode",
      rawName: "v-keycode",
      value: ('ENTER'),
      expression: "'ENTER'"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.create
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('v-table', {
    ref: "table",
    attrs: {
      "page": _vm.page,
      "table-minheight": 450
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "batchNo",
      "label": "编号",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "优惠券"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n         [" + _vm._s(row.promotionInfo.name) + "]-" + _vm._s(row.promotionInfo.discountCondition) + "\n        "), _c('span', {
          staticStyle: {
            "color": "gray"
          }
        }, [_vm._v(_vm._s(row.promotionInfo.tip))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "linkmanName",
      "label": "渠道",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n        " + _vm._s((row.promotionDispatchChannel || {}).name) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "expectNum",
      "label": "数量",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n        " + _vm._s(row.actualNum ? '已生成' : '未生成') + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createOn",
      "width": "140",
      "label": "创建时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n        " + _vm._s(row.createOn) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": "操作",
      "fixed": 'right'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.actualNum),
            expression: "!scope.row.actualNum"
          }]
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "title": "生成"
          },
          on: {
            "click": function($event) {
              return _vm.genCoupons(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-tickets"
        })]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "title": "编辑"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "title": "删除"
          },
          on: {
            "click": function($event) {
              return _vm.del(scope.row, scope.$index)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete red"
        })])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "title": "查看"
          },
          on: {
            "click": function($event) {
              return _vm.view(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-dialog', {
    ref: "formDiag",
    attrs: {
      "title": "信息编辑"
    }
  }, [_c('form-panel', {
    on: {
      "saved": _vm.onFormSaved
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.formDiag.dispatch('submit')
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    ref: "formDiagView",
    attrs: {
      "title": "信息查看"
    }
  }, [_c('view-panel')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a381569","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/act/promotionCouponBatch/Manage.vue
// module id = 328
// module chunks = 0